import React from "react"

import Section from "@components/section"

const En = () => {
  return (
    <>
      <Section title="Tournament Info">
        <table className="tableInfo">
          <tbody>
            <tr>
              <td>Schedule (Streaming)</td>
              <td>
                Jan. 16th (Saturday) 15:00 Tournament Pool Stage <br />
                Jan. 17th (Sunday) 15:00 Tournament Final Stage
                <br />
                <br />
                <a href="https://www.huya.com/spark2020" target="_blank">
                  Streaming : huya 660161
                </a>
              </td>
            </tr>
            <tr>
              <td>Type</td>
              <td>Offline Party</td>
            </tr>
            <tr>
              <td>System</td>
              <td>Double Elimination, Crew Battle</td>
            </tr>
            <tr>
              <td>Rules</td>
              <td>
                Best 2 out of 3 for Pools
                <br />
                Best 3 out of 5 for Finals
                <br />
                Stock: 3; Timer: 7:00; Items: Off
                <br />
                FS Meter: Off; Spirits: Off
                <br />
                Stage Selection: Loser's Pick
              </td>
            </tr>
            <tr>
              <td>Stages</td>
              <td>
                Starter：
                <br />
                Final Destination、Smashville、
                <br />
                Pokémon Stadium 2、Town and City、
                <br />
                Counterpick:
                <br />
                Kalos Pokémon League、Lylat Cruise、Yoshi's Story、Small <br />
                Battlefield
              </td>
            </tr>
            <tr>
              <td>Game version</td>
              <td>Latest version</td>
            </tr>
            <tr>
              <td>Registration</td>
              <td>
                1.Fill out the registration form.
                <br />
                2.Scan the QR code to join the attendees Wechat group.
                <br />
                3.Follow the instructions in the Wechat group.
              </td>
            </tr>
          </tbody>
        </table>
      </Section>
      <Section title="Notice of Contest">
        <div className="tips">
          <p>
            1.After the registration deadline, lots will be drawn by GAMECORES,
            the whole process will be issued to the chat group for confirmation.
          </p>

          <p>
            2.Any team is five minutes late or does not participate because of
            failure to arrive, leave early and other reasons, the team will be
            disqualified and the team's opponent will be awarded the victory.
          </p>

          <p>
            3.The ID, avatar, team name, clothing, carrying items, etc. of the
            player shall not contain any text, patterns or elements that include
            violation of the laws and regulations of the country or not suitable
            for appearance in the live broadcast of the contest. Any of the
            above prohibition, once verified, the team will be disqualified and
            stripped of their results;
          </p>

          <p>
            4.Players shall not make statements that violate national laws and
            regulations, insult or other statements that are not suitable for
            appearance in the live broadcast. In the event of the above
            prohibition, the team will be disqualified and stripped of their
            results.
          </p>

          <p>
            5.The GAMECORES CO. reserves all the right for final interpretation
            of the Contest.
          </p>
        </div>
      </Section>
    </>
  )
}

export default En
